import { defaultFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const benchmarkPageConfig = {
  namespacesRequired: ['processing', 'tables'],
  layout: {
    filterBar: defaultFilterBarConfig,
  },
} satisfies LayoutPageConfig;
